import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, styled, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import moment from "moment";

const DemoTypography = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    fontSize: 13
}));

const DemoTypo = styled(Typography)(({ theme }) => ({
    color: '#1565c0',
    fontSize: 13
}));

const Procurement = ({
    itemData
}) => {
    const requisition = itemData?.po_items?.find((a) => a.type === 'requisition');
    const po = itemData?.po_items?.find((a) => a.type === 'purchase_order');

    return (
        <>
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                <Typography varaint="body1" style={{ fontWeight: 'bold' }}>Procurement Information</Typography>
            </Box>
            <Accordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Box display="flex" justifyContent="space-between" alignItems="center" style={{ width: '100%' }}>
                        <Typography style={{ fontWeight: 'bold' }}>Procurement</Typography>
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Typography variant="body2" style={{ fontWeight: 'bold' }}>Quote</Typography>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <DemoTypo variant="body2">Quote #:</DemoTypo>
                                <DemoTypography variant="body2">{requisition?.quote || '--'}</DemoTypography>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <DemoTypo variant="body2">Received Date:</DemoTypo>
                                <DemoTypography variant="body2">{requisition?.quote_date ? moment(requisition?.quote_date).format('YYYY-MM-DD') : '--'}</DemoTypography>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <DemoTypo variant="body2">Expire Date:</DemoTypo>
                                <DemoTypography variant="body2">{requisition?.quote_expiration_date ? moment(requisition?.quote_expiration_date).format('YYYY-MM-DD') : '--'}</DemoTypography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="body2" style={{ fontWeight: 'bold' }}>Request</Typography>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <DemoTypo variant="body2">Request #:</DemoTypo>
                                <DemoTypography variant="body2">--</DemoTypography>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <DemoTypo variant="body2">Approved Date:</DemoTypo>
                                <DemoTypography variant="body2">--</DemoTypography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="body2" style={{ fontWeight: 'bold' }}>Requisition</Typography>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <DemoTypo variant="body2">Requisition #:</DemoTypo>
                                <DemoTypography variant="body2">{requisition?.action_no || '--'}</DemoTypography>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <DemoTypo variant="body2">Created Date:</DemoTypo>
                                <DemoTypography variant="body2">{requisition?.created_date ? moment(requisition?.created_date).format('YYYY-MM-DD') : '--'}</DemoTypography>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <DemoTypo variant="body2">Issue Date:</DemoTypo>
                                <DemoTypography variant="body2">{requisition?.issued_date ? moment(requisition?.issued_date).format('YYYY-MM-DD') : '--'}</DemoTypography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="body2" style={{ fontWeight: 'bold' }}>PO</Typography>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <DemoTypo variant="body2">PO #:</DemoTypo>
                                <DemoTypography variant="body2">{po?.action_no || '--'}</DemoTypography>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <DemoTypo variant="body2">Created Date:</DemoTypo>
                                <DemoTypography variant="body2">{po?.created_date ? moment(po?.created_date).format('YYYY-MM-DD') : '--'}</DemoTypography>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <DemoTypo variant="body2">Issue Date:</DemoTypo>
                                <DemoTypography variant="body2">{po?.issued_date ? moment(po?.issued_date).format('YYYY-MM-DD') : '--'}</DemoTypography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="body2" style={{ fontWeight: 'bold' }}>Sales</Typography>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <DemoTypo variant="body2">Sales Order #:</DemoTypo>
                                <DemoTypography variant="body2">--</DemoTypography>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <DemoTypo variant="body2">Issue Date:</DemoTypo>
                                <DemoTypography variant="body2">--</DemoTypography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="body2" style={{ fontWeight: 'bold' }}>Invoice</Typography>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <DemoTypo variant="body2">Invoice #:</DemoTypo>
                                <DemoTypography variant="body2">--</DemoTypography>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <DemoTypo variant="body2">Received Date:</DemoTypo>
                                <DemoTypography variant="body2">--</DemoTypography>
                            </Box>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </>
    )
};

export default Procurement;